(() => {
  'use strict';
  const root = document.querySelector('#MainContent[data-template*="raitooe-guide-v2"]');
  if (!root) return;

  const updateMatcher = (section) => {
    const result = section.querySelector('[data-gd2-result]');
    if (!result) return;
    const values = {
      title: result.dataset.defaultTitle || '',
      copy: result.dataset.defaultCopy || '',
      weight: result.dataset.defaultWeight || '',
      battery: result.dataset.defaultBattery || '',
      priority: result.dataset.defaultPriority || ''
    };
    ['distance', 'body', 'storage'].forEach((group) => {
      const option = section.querySelector(`[data-gd2-option][data-group="${group}"]:checked`);
      if (!option) return;
      Object.keys(values).forEach((key) => {
        if (option.dataset[key]) values[key] = option.dataset[key];
      });
    });
    Object.keys(values).forEach((key) => {
      const output = result.querySelector(`[data-gd2-result-${key}]`);
      if (output) output.textContent = values[key];
    });
  };

  root.addEventListener('change', (event) => {
    const input = event.target instanceof HTMLInputElement ? event.target : null;
    if (!input) return;
    if (input.matches('[data-gd2-option]')) {
      const section = input.closest('.gd2-matcher');
      if (section) updateMatcher(section);
      return;
    }
    if (input.matches('[data-gd2-ride-check]')) {
      const list = input.closest('[data-gd2-ride-list]');
      const section = input.closest('.gd2-ride');
      if (!list || !section) return;
      const total = Number(list.dataset.total) || 1;
      const checked = list.querySelectorAll('[data-gd2-ride-check]:checked').length;
      const count = section.querySelector('[data-gd2-ride-count]');
      const ring = section.querySelector('.gd2-ring-progress');
      if (count) count.innerHTML = `${checked}<small>/${total}</small>`;
      if (ring instanceof SVGElement) ring.style.strokeDashoffset = String(314 - (314 * checked / total));
    }
  });

  root.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const button = target?.closest('[data-gd2-lens]');
    if (!button) return;
    const section = button.closest('.gd2-lenses');
    section?.querySelectorAll('[data-gd2-lens]').forEach((item) => {
      const active = item === button;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', String(active));
    });
    ['label', 'title', 'copy', 'action'].forEach((key) => {
      const output = section?.querySelector(`[data-gd2-lens-${key}]`);
      if (output) output.textContent = button.dataset[key] || '';
    });
  });

  root.querySelectorAll('.gd2-matcher').forEach(updateMatcher);
})();
